import React, {useState} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {formatErrors} from "../../../constants";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {dichatGroupCreateAction, dichatGroupUpdateAction} from "../../../actions/dichatGroupAction";
import {InputProfile} from "../../../utils/input/InputProfile";

/**
 * Заведение и переименование болталки.
 *
 * Название клиентка видит в списке чатов, поэтому пустым его не оставляем, а
 * переименование меняет имя и в комнате — иначе куратор и клиентка говорили бы
 * о разных болталках.
 */
export function DichatGroupModal({item, trigger, triggerWrap, onSuccess}) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState(item ? item.title : '');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    if (value) {
      setTitle(item ? item.title : '');
      setError(false);
    }
    setOpen(value);
  };

  const handleSubmit = () => {
    if (loading) {
      return false;
    }
    if (title.trim() === '') {
      setError(true);
      return false;
    }
    setError(false);
    setLoading(true);

    const request = item
      ? dispatch(dichatGroupUpdateAction(item.id, {title: title.trim()}))
      : dispatch(dichatGroupCreateAction(title.trim()));

    request.then(() => {
      setLoading(false);
      setOpen(false);
      onSuccess();
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={triggerWrap}>
    <React.Fragment>
      <div className="modal__title">{item ? "Переименовать" : "Завести"} болталку</div>
      <div className="modal__wrap">
        <InputProfile type="text"
                      title="Название"
                      name="title"
                      placeholder="Например: Болталка марта"
                      value={title}
                      error={error}
                      disabled={loading}
                      onChange={(e) => setTitle(e.target.value)}/>
      </div>
      <div className="modal__btns">
        <button type="button" className="modal__btn btn" onClick={handleSubmit} disabled={loading}>Сохранить</button>
      </div>
    </React.Fragment>
  </Modal>;
}
